import type { AnnotatedJsonSchema7 } from '@web-config-app/core';

/* ===== BASE INPUT CONTROL ===== */

export const baseInputControlMockSubschema = {
  title: 'Name',
  description: 'Human readable',
  'x-entity-label': {
    key: 'MOCK_BASE_INPUT_CONTROL_LABEL',
  },
  'x-entity-presentation': {
    hint: {
      key: 'MOCK_BASE_INPUT_HINT',
      values: {
        href: 'www.google.com',
      },
    },
  },
} as const;

export const mockBaseInputControlProps = {
  description: baseInputControlMockSubschema.description,
  label: baseInputControlMockSubschema.title,
  visible: true,
  id: 'property_id',
  errors: '',
  enabled: true,
  required: true,
  path: 'text',
  handleChange: () => {},
};

export const textInputControlMockSubSchema = {
  ...baseInputControlMockSubschema,
  type: 'string',
} as const;

export const numberInputControlMockSubSchema = {
  ...baseInputControlMockSubschema,
  type: 'number',
  title: 'Age',
};

/* ===== COMBINATOR INPUT CONTROL ===== */

export const combinatorObjectInputControlMockSubSchema = {
  ...baseInputControlMockSubschema,
  type: 'object',
  title: 'Address or User',
  'x-entity-label': {
    key: 'LOCATION',
  },
  'x-entity-presentation': {
    hint: baseInputControlMockSubschema['x-entity-presentation'].hint,
  },
  discriminator: {
    propertyName: 'componentType',
    'x-entity-label': {
      key: 'LOCATION_TYPE',
    },
    'x-entity-presentation': {
      hint: {
        key: 'LOCATION_TYPE_HINT',
      },
      enumLabels: {
        enumControlPlaceholder: 'SELECT_LOCATION_OPTION',
      },
    },
  },
  oneOf: [
    {
      type: 'object',
      title: 'Address',
      properties: {
        componentType: {
          type: 'string',
          enum: ['address'],
          'x-entity-label': { key: 'ADDRESS_KEY' },
          'x-entity-presentation': { hidden: true },
        },
        street_address: {
          type: 'string',
          'x-entity-label': { key: 'STREET_ADDRESS' },
        },
        city: {
          type: 'string',
          'x-entity-label': { key: 'CITY' },
        },
        state: {
          type: 'string',
          'x-entity-label': { key: 'STATE' },
        },
      },
      required: ['street_address', 'city', 'state'],
    },
    {
      type: 'object',
      title: 'User',
      properties: {
        componentType: {
          type: 'string',
          enum: ['user'],
          'x-entity-label': { key: 'USER_KEY' },
          'x-entity-presentation': { hidden: true },
        },
        name: {
          type: 'string',
          'x-entity-label': { key: 'NAME' },
        },
        mail: {
          type: 'string',
          'x-entity-label': { key: 'MAIL' },
        },
      },
      required: ['name', 'mail'],
    },
  ] as AnnotatedJsonSchema7[],
};

export const combinatorSubSchemaOneOfWithHiddenArray = [
  combinatorObjectInputControlMockSubSchema.oneOf[0],
  {
    ...combinatorObjectInputControlMockSubSchema.oneOf[1],
    'x-entity-presentation': { hidden: true },
  },
];

export const combinatorObjectInputControlMockSubSchemaWithHidden = {
  ...combinatorObjectInputControlMockSubSchema,
  oneOf: combinatorSubSchemaOneOfWithHiddenArray,
};

export const mockCombinatorInputControlProps = {
  ...mockBaseInputControlProps,
  schema: combinatorObjectInputControlMockSubSchema,
  uischema: { type: 'Control', scope: 'mock-scope' } as const,
  rootSchema: {
    type: 'object',
    properties: {
      addressOrUser: combinatorObjectInputControlMockSubSchema,
    },
  },
};
